import { StateToken } from '@ngxs/store';

import { CustomerSubscription, PlanConstraints } from '@app/core/models/customer.models';

export interface SubscriptionStateModel {
  details?: CustomerSubscription;
  preview?: CustomerSubscription[];
  constraints?: PlanConstraints;
}

export const CUSTOMER_SUBSCRIPTION_STATE_TOKEN = new StateToken<SubscriptionStateModel>('customerSubscription');
